//region block: pre-declaration
//endregion
function asByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
}
//region block: exports
export {
  asByteArray as asByteArray281a45t1cr5zc,
};
//endregion

//# sourceMappingURL=ReadableStream.mjs.map
